import {Component, Input, OnInit, OnDestroy} from "@angular/core";
import {AuthentService} from "../../services/authent.service";
import {UploadService} from "../../services/uploadService";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";
import {Business} from "../../model/business";
import {ConfigurationService} from "../../services/configuration.service";
import {NavBarService} from "../../services/communication/nav-bar.service";
import {Subscription} from "rxjs";

declare const $:any;

@Component({
  selector: 'nav-bar',
  template: require('./nav-bar.component.html'),
  styles: [
    require('./nav-bar.component.scss')
  ]
})

export class NavBarComponent implements OnInit, OnDestroy {

  ngOnInit(): void {
    this.businessSubscription = this.currentBusinessService.businessChange$.subscribe(
      business => this.business = business
    );

    this.logSubscription = this.authentService.loggedIn$.subscribe(logged => {
      if(logged) {
        this.familiesLink = this.configuration.getFamiliesUrl()+'/app/#/index/'+this.authentService.getToken();
      }
    });

    this.navBarSubscription = this.navBarService.navBarChange$.subscribe(
      activeBackground => this.background = activeBackground
    );
  }

  ngOnDestroy(): void {
    this.businessSubscription.unsubscribe();
    this.logSubscription.unsubscribe();
    this.navBarSubscription.unsubscribe();
  }

  @Input() isLogged:boolean = false;
  active:string;
  familiesLink:string;

  business:Business;

  background: boolean = false;

  private businessSubscription: Subscription;
  private logSubscription: Subscription;
  private navBarSubscription: Subscription;

  constructor(private authentService:AuthentService, private uploadService:UploadService,
              private currentBusinessService:CurrentBusinessService, private configuration: ConfigurationService,
              private navBarService: NavBarService) {

    this.familiesLink = configuration.getFamiliesUrl()+'/app/#/index/'+authentService.getToken();

    let that = this;
    $(document).ready(function () {

      $(document).on('click', '.trigger-collapse', function (event) {
        that.collapseNavBar();
      });

      $(document).on('click', '.container', function () {
        that.collapseNavBar();
      });
    });
  }

  collapseNavBar() {
    let $collapse = $(".navbar-collapse");

    if($collapse.hasClass('in')) {
      $collapse.collapse('hide');
    }
  }

  logout():void {
    this.business = null;
    this.currentBusinessService.clear();
    this.authentService.logout();
  }

  changeView(view:string) {
    this.active = view;
    this.uploadService.changeShow(false);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/nav-bar/nav-bar.component.ts